const map = {
	"./2018/Masterclass/Index.vue": 9102,
	"./2022/Masterclass/Index.vue": 99463,
	"./2023/Masterclass/Index.vue": 26473,
	"./2024/Masterclass/Index.vue": 94065,
	"./2025/Masterclass/Index.vue": 17627,
	"./2026/Masterclass/Index.vue": 24555
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53847;